<div class="header">
  <h2>Modifica <strong>Convenzione</strong></h2>
  <div class="breadcrumb-wrapper hidden-xs">
    <ol class="breadcrumb">
      <li><a routerLink="/contract">Convenzione</a></li>
      <li class="active">Modifica Convenzione</li>
    </ol>
  </div>
</div>
<div class="row">
  <div class="col-lg-12 portlets">
    <div class="panel">
      <div class="panel-content">
        <form (ngSubmit)="onSubmit()" #contractUpdateForm="ngForm" role="form" class="form-horizontal form-validation">
          <div class="form-group">
            <label for="code" class="col-sm-3 control-label">Codice *</label>
            <div class="col-sm-6 prepend-icon">
              <input type="text"
                     id="code"
                     name="code"
                     class="form-control"
                     placeholder="Inserisci Codice..."
                     required
                     autocomplete="off"
                     [ngClass]="{
                        'form-error': !(code.valid || code.pristine),
                        'form-success': code.valid
                     }"
                     [(ngModel)]="contract.code"
                     #code="ngModel">
              <i class="icon-key"></i>
              <div [hidden]="code.valid || code.pristine"
                   class="form-error valid">
                Il codice presenta un errore.
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="title" class="col-sm-3 control-label">Nome *</label>
            <div class="col-sm-6 prepend-icon">
              <input type="text"
                     id="title"
                     name="title"
                     class="form-control"
                     placeholder="Inserisci Nome..."
                     minlength="3"
                     required
                     autocomplete="off"
                     [ngClass]="{
                        'form-error': !(name.valid || name.pristine),
                        'form-success': name.valid
                     }"
                     [(ngModel)]="contract.name"
                     #name="ngModel">
              <i class="icon-info"></i>
              <div [hidden]="name.valid || name.pristine"
                   class="form-error valid">
                Inserisci almeno 3 caratteri.
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="subject" class="col-sm-3 control-label">Oggetto della Fornitura *</label>
            <div class="col-sm-6 prepend-icon">
              <input type="text"
                     id="subject"
                     name="subject"
                     class="form-control"
                     placeholder="Inserisci Oggetto della Fornitura..."
                     required
                     autocomplete="off"
                     [ngClass]="{
                        'form-error': !(subject.valid || subject.pristine),
                        'form-success': subject.valid
                     }"
                     [(ngModel)]="contract.subject"
                     #subject="ngModel">
              <i class="icon-social-dropbox"></i>
              <div [hidden]="subject.valid || subject.pristine"
                   class="form-error valid">
                L'Oggetto della Fornitura è richiesto.
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="founder" class="col-sm-3 control-label">Fornitore *</label>
            <div class="col-sm-5">
              <select class="form-control"
                      name="founder"
                      id="founder"
                      style="width:100%;"
                      required
                      [(ngModel)]="contract.fk_id_contract_founder">
                <option [ngValue]="" disabled selected>Seleziona Fornitore...</option>
                <option *ngFor="let contractFounder of contractFounders" [ngValue]="contractFounder.id_contract_founder">{{ contractFounder.name }}</option>
              </select>
            </div>
            <div class="col-sm-1"><button type="button" class="btn btn-success" style="cursor: pointer;" (click)="openContracFounderCreateModal()"><i class="icon-plus"></i>Nuovo</button></div>
          </div>

          <div class="form-group">
            <label for="user" class="col-sm-3 control-label">Checklist *</label>
            <div class="col-sm-6">
              <select class="form-control"
                      name="user"
                      id="user"
                      style="width:100%;"
                      required
                      [(ngModel)]="contract.fk_id_checklist">
                <option [ngValue]="" disabled selected>Seleziona Checklist...</option>
                <option *ngFor="let checklist of checklists" [ngValue]="checklist.id_checklist">{{ checklist.name }}</option>
              </select>
            </div>
          </div>

          <div class="form-group">
            <label for="lot" class="col-sm-3 control-label">Lotto *</label>
            <div class="col-sm-6 prepend-icon">
              <input type="text"
                     id="lot"
                     name="lot"
                     class="form-control"
                     placeholder="Inserisci Lotto..."
                     required
                     autocomplete="off"
                     [ngClass]="{
                        'form-error': !(lot.valid || lot.pristine),
                        'form-success': lot.valid
                     }"
                     [(ngModel)]="contract.lot"
                     #lot="ngModel">
              <i class="icon-info"></i>
              <div [hidden]="lot.valid || lot.pristine"
                   class="form-error valid">
                Il Lotto è richiesto.
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="start" class="col-sm-3 control-label">Data Inizio *</label>
            <div class="col-sm-6 prepend-icon">
              <input matInput
                     [matDatepicker]="dateStartPicker"
                     id="start"
                     name="start"
                     class="form-control"
                     data-lang="it"
                     data-autoclose="true"
                     data-orientation="bottom left"
                     autocomplete="off"
                     placeholder="Inserisci Data Inizio (gg/mm/aaaa)..."
                     required
                     [ngClass]="{
                        'form-success': contract.start !== null
                     }"
                     [ngModel]="contract.start"
                     (ngModelChange)="contract.start = $event"
                     (click)="dateStartPicker.open()">
              <i class="icon-calendar"></i>
              <mat-datepicker #dateStartPicker></mat-datepicker>
            </div>
          </div>

          <div class="form-group">
            <label for="end" class="col-sm-3 control-label">Data Fine *</label>
            <div class="col-sm-6 prepend-icon">
              <input matInput
                     [matDatepicker]="dateEndPicker"
                     id="end"
                     name="end"
                     class="form-control"
                     data-lang="it"
                     data-autoclose="true"
                     data-orientation="bottom left"
                     autocomplete="off"
                     placeholder="Inserisci Data Fine (gg/mm/aaaa)..."
                     required
                     [ngClass]="{
                        'form-success': contract.end !== null
                     }"
                     [ngModel]="contract.end"
                     (ngModelChange)="contract.end = $event"
                     (click)="dateEndPicker.open()">
              <i class="icon-calendar"></i>
              <mat-datepicker #dateEndPicker></mat-datepicker>
            </div>
          </div>

          <div class="text-center m-t-20">
            <button type="submit"
                    class="btn btn-embossed btn-primary"
                    [disabled]="!contractUpdateForm.form.valid">
              <i class="icon-pencil"></i> Modifica Convenzione</button>
          </div>

          <div [hidden]="contractUpdateResult" class="alert alert-danger">
            La convenzione inserita presenta un errore, riprovare.
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
